<template>
  <v-container
    grid-list-xl
    fluid
  >
    <v-layout
      row
      wrap
    >
      <v-flex xs12>
        <FilterButtons
          :filters="appliedFilters"
          @filter-removed="removeFilter"
        />

        <MassActionSelect
          :actions="massActions"
          @action-selected="dispatchAction"
        />

        <CollectionFilters
          :filters="filters"
          :active-filters="appliedFilters"
          @filters-submitted="submitFilters"
          @filters-cleared="clearFilters"
        />

        <v-data-table
          v-model="selected"
          :loading="loading"
          :headers="headers"
          :items="collection"
          :total-items="meta.totalItems"
          :rows-per-page-text="$t('Rows per page')"
          :rows-per-page-items="meta.rowsPerPageItems"
          :pagination.sync="pagination"
          show-select
          select-all
          class="elevation-1"
          item-key="id"
        >
          <v-progress-linear
            slot="progress"
            color="primary"
            indeterminate
          />

          <template v-slot:items="props">
            <TaxonomyDataTableRow :props="props" />
          </template>

          <template slot="no-data">
            <v-btn
              color="primary"
              @click="clearFilters"
            >
              {{ $t('Reset') }}
            </v-btn>
          </template>
          <template v-slot:pageText="props">
            <span>{{ $t('{0} - {1} of {2}', [props.pageStart, props.pageStop, props.itemsLength]) }}</span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TaxonomyDataTableRow from '../components/TaxonomyDataTableRow'
import MassActionSelect from '../../../vuetify-console/components/MassActionSelect'
import CollectionFilters from '../../../vuetify-console/components/CollectionFilters'
import FilterButtons from '../../../vuetify-console/components/FilterButtons'

import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters } = createNamespacedHelpers('catalog/taxonomy')

export default {
  name: 'TaxonomyList',

  components: {
    TaxonomyDataTableRow,
    MassActionSelect,
    CollectionFilters,
    FilterButtons
  },

  actionBar () {
    return {
      title: 'Taxonomy',
      actions: [
        {
          text: 'Create taxonomy',
          event: 'add'
        }
      ]
    }
  },

  data () {
    return {
      selected: []
    }
  },

  computed: {
    ...mapGetters(['collection', 'loading', 'meta', 'appliedFilters']),

    pagination: {
      get: function () {
        return this.meta
      },
      set: function (value) {
        this.applyMeta(value)
      }
    },

    headers () {
      return [
        { text: this.$t('Sort Order'), value: 'order' },
        { text: this.$t('Code'), value: 'code' },
        { text: this.$t('Single name'), value: 'name' },
        { text: this.$t('Product count'), value: 'products' },
        { text: this.$t('Full taxonomy'), value: 'fullTaxonomy' }
      ]
    },

    massActions () {
      return [
        { code: 'delete', label: this.$t('Delete') }
      ]
    },

    filters () {
      return [
        { field: 'code', type: 'string', label: this.$t('Code') },
        { field: 'name', type: 'string', label: this.$t('Name') }
      ]
    }
  },

  methods: {
    ...mapActions(['applyMeta', 'fetchCollection', 'removeFilter', 'clearFilters']),

    buildFullTaxonomy (root) {
      root.fullTaxonomy = []
      this.getParentsRecursively(root.fullTaxonomy, root)
      root.fullTaxonomy.reverse()
      root.fullTaxonomy.push(root.name)
      return root.fullTaxonomy.join(' > ')
    },

    getParentsRecursively (taxonomy, item) {
      if (!item.parent) {
        return
      }
      taxonomy.push(item.parent.name)
      this.getParentsRecursively(taxonomy, item.parent)
    },

    onActionAdd () {
      this.$router.push({ name: 'single-taxonomy', params: { id: '__' } })
    },

    dispatchAction (action) {
      if (action === 'delete') {
        this.deleteSelected()
      }
    },

    async deleteSelected () {
      let taxonomies = null
      if (this.selected.length) {
        taxonomies = this.selected.map(item => item.id)
      }

      await this.$http.make('taxonomy').massDelete(taxonomies)
      this.selected = []
      this.$toast.success(this.$t('Deleting records.'))
    },

    submitFilters (filters) {
      this.applyMeta({ filters })
    }
  }
}
</script>
